// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__32SKp","large":"styles_large__2Zkp6"};